import { TextField, Typography } from '@mui/material'

interface SearchBarProps {
    label: string
    searchTerm: string
    setSearchTerm: (value: string) => void
}

export const SearchBar = ({ label, searchTerm, setSearchTerm }: SearchBarProps) => {
    return (
        <>
            <Typography sx={{ fontWeight: 'bold', paddingLeft: '4px' }}>{label}</Typography>
            <TextField
                data-test="search-bar"
                variant="outlined"
                placeholder={label}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{ width: '300px', '& .MuiOutlinedInput-root': { height: '40px' } }}
            />
        </>
    )
}

export default SearchBar
